export default __webpack_public_path__ + "static/media/WinSP_logo.6f460290.png";